/**
 * The ungated preview bar's look, apart from its component so a spec can draw the same bar without
 * the build's preview-sha define, which buildConstants.ts reads (a Playwright process has none).
 */
export const UNGATED_PREVIEW_BAR_CLASS =
  'items-center gap-2 border-t border-violet-200 bg-violet-50 px-4 py-1 text-[12px] leading-5 text-violet-950 dark:border-violet-700/60 dark:bg-[#231d33] dark:text-violet-100';
